define(['../validation', '../../util.js'], function(validation, util) {
    'use strict';
    validation.addCustomValidationRule('equality', function(val, options) {
        return util.isEqual(val, options.compareTo);
    });
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/validation/rules/equality.js
 ** module id = 110
 ** module chunks = 0
 **/